import React from 'react';
import { useSelector } from 'react-redux';
import { TableRow } from './';

const BookingTable = () => {
  const flights = useSelector((state) => state);

  return (
    <table className="booking-table">
      <thead className="bg-gray-100/50">
        <tr className="text-black text-left">
          <th>Destination From</th>
          <th>Destination To</th>
          <th className="text-center">Journey Date</th>
          <th className="text-center">Guests</th>
          <th className="text-center">Class</th>
          <th className="text-center">Delete</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
        {flights.map((flight, idx) => {
          return <TableRow key={idx} id={idx} {...flight} />;
        })}
      </tbody>
    </table>
  );
};

export default BookingTable;
